module.exports = __webpack_public_path__ + "img/14brsjb_02.967b85af.jpg";